export const GET_SESSION = 'GET_SESSION'
export const GET_SESSION_FAILED = 'GET_SESSION_FAILED'
export const GET_SESSION_SUCCEEDED = 'GET_SESSION_SUCCEEDED'

export const CREATE_SESSION = 'CREATE_SESSION'
export const CREATE_SESSION_FAILED = 'CREATE_SESSION_FAILED'
export const CREATE_SESSION_SUCCEEDED = 'CREATE_SESSION_SUCCEEDED'

export const REFRESH_SESSION = 'REFRESH_SESSION'
export const REFRESH_SESSION_FAILED = 'REFRESH_SESSION_FAILED'
export const REFRESH_SESSION_SUCCEEDED = 'REFRESH_SESSION_SUCCEEDED'

export const DESTROY_SESSION = 'DESTROY_SESSION'
export const DESTROY_SESSION_FAILED = 'DESTROY_SESSION_FAILED'
export const DESTROY_SESSION_SUCCEEDED = 'DESTROY_SESSION_SUCCEEDED'

export const CREATE_SESSION_BY_OAUTH2 = 'CREATE_SESSION_BY_OAUTH2'
export const CREATE_SESSION_BY_OAUTH2_FAILED = 'CREATE_SESSION_BY_OAUTH2_FAILED'
export const CREATE_SESSION_BY_OAUTH2_SUCCEEDED = 'CREATE_SESSION_BY_OAUTH2_SUCCEEDED'

export const GET_DROPBOX_OAUTH_URL = 'GET_DROPBOX_OAUTH_URL'
export const GET_DROPBOX_OAUTH_URL_FAILED = 'GET_DROPBOX_OAUTH_URL_FAILED'
export const GET_DROPBOX_OAUTH_URL_SUCCEEDED = 'GET_DROPBOX_OAUTH_URL_SUCCEEDED'

export const GET_OFFICE365_ACCESS_TOKEN = 'GET_OFFICE365_ACCESS_TOKEN'
export const GET_OFFICE365_ACCESS_TOKEN_FAILED = 'GET_OFFICE365_ACCESS_TOKEN_FAILED'
export const GET_OFFICE365_ACCESS_TOKEN_SUCCEEDED = 'GET_OFFICE365_ACCESS_TOKEN_SUCCEEDED'

export const CLEAR_APP_STATE = 'CLEAR_APP_STATE'

export const INIT_AUTH_KEY = 'INIT_AUTH_KEY'
